(() => {
  const form = document.getElementById('CreateAccountForm');
  if (!form) return;

  const isIOS =
    /iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (isIOS) {
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    if (viewportMeta && !viewportMeta.content.includes('maximum-scale')) {
      viewportMeta.content = `${viewportMeta.content}, maximum-scale=1`;
    }
  }

  const HUBSPOT_PORTAL_ID = '21871179';
  const HUBSPOT_FORM_ID = 'dfb46108-04f2-4094-8a02-e52c0fbaf797';
  const HUBSPOT_SUBMIT_URL = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${HUBSPOT_FORM_ID}`;

  const submitLeadToHubspot = (fields) => {
    const payload = {
      fields: [
        { objectTypeId: '0-1', name: 'company', value: fields.company },
        { objectTypeId: '0-1', name: 'firstname', value: fields.firstname },
        { objectTypeId: '0-1', name: 'lastname', value: fields.lastname },
        { objectTypeId: '0-1', name: 'email', value: fields.email },
      ],
      context: {
        pageUri: window.location.href,
        pageName: document.title,
      },
    };
    const hutk = document.cookie.match(/(?:^|; )hubspotutk=([^;]+)/);
    if (hutk) payload.context.hutk = hutk[1];

    return fetch(HUBSPOT_SUBMIT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  };

  const REGISTER_URL = '/apps/account/register';

  const submitRegistration = (fields) => {
    const data = new FormData();
    data.set('company', fields.company);
    data.set('first_name', fields.firstname);
    data.set('last_name', fields.lastname);
    data.set('email', fields.email);
    data.set('website', form.elements.website ? form.elements.website.value : '');
    return fetch(REGISTER_URL, { method: 'POST', body: data })
      .then((response) => response.json())
      .catch(() => null);
  };

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const setFieldError = (input, hasError) => {
    const wrapper = input.closest('[data-field]');
    const message = wrapper?.querySelector('.create-account__error');
    wrapper?.classList.toggle('create-account__field--error', hasError);
    input.setAttribute('aria-invalid', hasError ? 'true' : 'false');
    if (message) message.hidden = !hasError;
  };

  const validate = () => {
    let firstInvalid = null;
    form.querySelectorAll('input[required]').forEach((input) => {
      const value = input.value.trim();
      const invalid = value === '' || (input.type === 'email' && !isValidEmail(value));
      setFieldError(input, invalid);
      if (invalid && !firstInvalid) firstInvalid = input;
    });
    firstInvalid?.focus();
    return !firstInvalid;
  };

  // A locked product sends guests here with ?return_to=<product path> so they
  // land back on that product after signing in. Only same-origin paths are
  // honored; otherwise fall back to the portal.
  const resolveReturnTo = () => {
    const raw = new URLSearchParams(window.location.search).get('return_to');
    if (raw && /^\/(?!\/)/.test(raw)) return raw;
    return '/apps/account';
  };
  const returnTo = resolveReturnTo();

  const buildSignInUrl = (email) => {
    const url = new URL(form.dataset.loginUrl, window.location.origin);
    url.searchParams.set('login_hint', email);
    url.searchParams.set('return_to', returnTo);
    return url.toString();
  };

  document.querySelectorAll('.create-account__signin-link').forEach((link) => {
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('return_to', returnTo);
    link.href = url.toString();
  });

  form.querySelectorAll('input[required]').forEach((input) => {
    input.addEventListener('input', () => setFieldError(input, false));
  });

  const showExistingAccountNotice = (email) => {
    const notice = document.getElementById('CreateAccountExists');
    if (!notice) return false;
    const link = notice.querySelector('[data-existing-signin]');
    if (link) link.href = buildSignInUrl(email);
    notice.hidden = false;
    notice.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    return true;
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!validate()) return;

    const fields = {
      company: form.elements.company.value.trim(),
      firstname: form.elements.first_name.value.trim(),
      lastname: form.elements.last_name.value.trim(),
      email: form.elements.email.value.trim(),
    };

    const submitButton = form.querySelector('.create-account__submit');
    submitButton.disabled = true;

    const registrationTimeout = new Promise((resolve) => setTimeout(resolve, 4000, null));
    const hubspotTimeout = new Promise((resolve) => setTimeout(resolve, 2500));
    const [registration] = await Promise.all([
      Promise.race([submitRegistration(fields), registrationTimeout]),
      Promise.race([submitLeadToHubspot(fields).catch(() => {}), hubspotTimeout]),
    ]);

    if (registration && registration.code === 'exists' && showExistingAccountNotice(fields.email)) {
      submitButton.disabled = false;
      return;
    }

    window.location.assign(buildSignInUrl(fields.email));
  });
})();
